import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkflowsService {

  constructor(
    private http: HttpClient
  ) { }

  getWorkflows(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/trackvision/workflow`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    });
  }
}
